import { forwardRef } from 'react';
import { Input } from 'components/ui';
import AuthFieldShell from 'pages/Auth/components/AuthFieldShell';
import { AuthTextFieldProps } from './AuthTextField.props';

const AuthTextField = forwardRef<HTMLInputElement, AuthTextFieldProps>(
  ({ disabled, error, helperText, hideLabel = false, id, label, placeholder, sx, type = 'text', ...props }, ref) => (
    <AuthFieldShell error={error} helperText={helperText} hideLabel={hideLabel} id={id} label={label}>
      {resolvedHelperText => (
        <Input
          disabled={disabled}
          error={error}
          helperText={resolvedHelperText}
          hiddenLabel
          id={id}
          inputRef={ref}
          placeholder={placeholder}
          sx={sx}
          type={type}
          variant="outlined"
          visualVariant="compactOutlined"
          {...props}
        />
      )}
    </AuthFieldShell>
  )
);

AuthTextField.displayName = 'AuthTextField';

export default AuthTextField;
